import React from 'react';

import { NotificatiionSnackbarP } from 'components/NotificationsModal/styles';
import {
	NewsletterContextProps,
	useNewsletterContext
} from 'context-providers/newsletterContextProvider';
import { useTranslationsContext } from 'contexts/translationsContext';
import { PremiumNewsletter } from 'models/newsletter';
import { NewslettersProps } from 'models/props';
import { useIsLessThan } from 'fxs-utils';

import { IconCheck, IconX } from '@tabler/icons-react';

import { Envelope } from './envelope';
import { NewsletterRow } from './newsletterRow';
import {
	CloseIcon,
	NewslettersBackdrop,
	NewslettersCloseText,
	NewslettersDescription,
	NewslettersGreybox,
	NewslettersIcon,
	NewslettersModalAllOnP,
	NewslettersModalAllOnWrapper,
	NewslettersModalBody,
	NewslettersModalBtnReset,
	NewslettersModalBtnSave,
	NewslettersModalBtnWrapper,
	NewslettersModalCheckbox,
	NewslettersModalSwitchCircle,
	NewslettersModalSwitchWrapper,
	NewslettersSidebar,
	NewslettersSidebarHeader,
	NewslettersSidebarTitle,
	NewslettersSnackbar
} from './styles';

const NewslettersModal: React.FC<NewslettersProps> = ({
	elementRef,
	isNewslettersModalOpened,
	setIsNewslettersModalOpened
}) => {
	const { t } = useTranslationsContext();
	const isLessThan833 = useIsLessThan(833);
	const dismissedNewslettersDescription = localStorage.getItem(
		'dismissedNewslettersDescription'
	);

	const handleCloseModal = (
		e: React.MouseEvent<
			HTMLDivElement | SVGSVGElement | HTMLButtonElement,
			MouseEvent
		>
	) => {
		e.stopPropagation();
		setIsNewslettersModalOpened(false);
	};

	const {
		error,
		subscribedToAllNewsletters,
		newsletters,
		handleSubscribeAll,
		isLoading,
		setNewsletters,
		setChanged,
		saveNewsletters,
		resetNewsletters,
		changed,
		saved
	} = useNewsletterContext() as NewsletterContextProps;

	return (
		<NewslettersBackdrop
			isNewslettersModalOpened={isNewslettersModalOpened}
		>
			<NewslettersSidebar ref={elementRef}>
				<div>
					<NewslettersSidebarHeader>
						<NewslettersSidebarTitle>
							{t('PremiumNewsletters')}
						</NewslettersSidebarTitle>
						<CloseIcon
							as={IconX}
							stroke={2}
							onClick={handleCloseModal}
						/>
					</NewslettersSidebarHeader>
					{!dismissedNewslettersDescription && (
						<NewslettersGreybox show={true}>
							<div>
								<NewslettersDescription>
									{t('NewslettersDescription')}
								</NewslettersDescription>
								<NewslettersCloseText
									onClick={(e) => {
										handleCloseModal(e);
										localStorage.setItem(
											'dismissedNewslettersDescription',
											'true'
										);
									}}
								>
									{t('NewslettersCloseText')}
								</NewslettersCloseText>
							</div>
							<Envelope />
						</NewslettersGreybox>
					)}
					<NewslettersModalBody>
						<NewslettersModalAllOnWrapper>
							<NewslettersModalAllOnP>
								{t('AllNewsletters')}
							</NewslettersModalAllOnP>
							<NewslettersModalCheckbox>
								<NewslettersModalSwitchWrapper
									isActive={subscribedToAllNewsletters(
										newsletters
									)}
									onClick={() => {
										handleSubscribeAll(newsletters);
									}}
								>
									<NewslettersModalSwitchCircle
										isActive={subscribedToAllNewsletters(
											newsletters
										)}
										onClick={() => {
											handleSubscribeAll(newsletters);
										}}
									/>
								</NewslettersModalSwitchWrapper>
							</NewslettersModalCheckbox>
						</NewslettersModalAllOnWrapper>
						{isLoading ? (
							<p className='loading'>Loading...</p>
						) : error ? (
							<p className='error'>{error}</p>
						) : (
							newsletters.map((newsletter: PremiumNewsletter) => (
								<NewsletterRow
									newsletter={newsletter}
									setNewsletters={setNewsletters}
									newsletters={newsletters}
									setChanged={setChanged}
									key={newsletter.Id}
								/>
							))
						)}
					</NewslettersModalBody>
				</div>
				<NewslettersModalBtnWrapper>
					{saved && (
						<NewslettersSnackbar>
							<NewslettersIcon as={IconCheck} stroke={2} />
							<NotificatiionSnackbarP>
								{t('changesSaved')}
							</NotificatiionSnackbarP>
						</NewslettersSnackbar>
					)}

					<NewslettersModalBtnSave
						onClick={() => {
							saveNewsletters(setIsNewslettersModalOpened);
						}}
						disabled={!changed}
					>
						{t('save')} {isLessThan833 ? '' : t('preferences')}
					</NewslettersModalBtnSave>
					<NewslettersModalBtnReset
						onClick={resetNewsletters}
						disabled={!changed}
					>
						{t('reset')} {isLessThan833 ? '' : t('preferences')}
					</NewslettersModalBtnReset>
				</NewslettersModalBtnWrapper>
			</NewslettersSidebar>
		</NewslettersBackdrop>
	);
};
export default NewslettersModal;
